const initSwiper = (el) => {
  if (el.__swiperInstance) return;

  let config = {};
  try {
    config = JSON.parse(el.getAttribute("data-swiper") || "{}");
  } catch (err) {
    console.warn("Invalid JSON in data-swiper:", err);
  }

  el.__swiperInstance = new Swiper(el, config);
};

const observeSwipers = () => {
  const initAll = () => {
    document.querySelectorAll("[data-swiper]").forEach(initSwiper);
  };

  const observer = new MutationObserver(() => initAll());
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  initAll();
};

document.addEventListener("DOMContentLoaded", observeSwipers);
